module.exports = __webpack_public_path__ + "static/img/aboutUsKv.2bd0b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsKv.png
// module id = vYhm
// module chunks = 1